import styled from 'styled-components'

export const InsuranceCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(8)};
  padding: ${({ theme }) => theme.rem(20, 16)};
  border-radius: ${({ theme }) => theme.rem(16)};
  margin: ${({ theme }) => theme.rem(16, 0)};

  background-color: ${({ theme, pageContext }) => {
    if (pageContext?.pageType === 'educational-danni') {
      return theme.colors.educational.danni[10]
    } else if (pageContext?.pageType === 'educational-vita') {
      return theme.colors.educational.vita[10]
    } else {
      return '#e9f8f8'
    }
  }};
`

export const InsuranceCardIcon = styled.div``

export const InsuranceCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(8)};
`
